module.exports = __webpack_public_path__ + "static/opt_x0.ba5083e4.png";